import { useGoogleReCaptcha } from "react-google-recaptcha-v3"

const useRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const verifyRecaptcha = async () => {
    if (!executeRecaptcha) {
      throw new Error("executeRecaptcha not yet available.")
    }

    const token = await executeRecaptcha()

    const response = await fetch("/api/account/verify-captcha-token", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ token }),
    })

    if (!response.ok) {
      const error = await response.json()
      throw new Error(error?.message)
    }

    return response.json()
  }

  return { verifyRecaptcha }
}

export default useRecaptcha
